import React from 'react'
import '../styles/layout/Services.css'
import { Container, Image } from 'react-bootstrap';
import banner from '../assests/Services.png'

const ServiceBanner = () => {
  return (
    <section className="page-hero svcHero">
      <Container>
        <div className="page-hero__band">
          <Image src={banner} alt="" />
          <span className="page-hero__band-tint" aria-hidden="true" />
          <span className="page-hero__band-wash" aria-hidden="true" />
          <span className="page-hero__band-edge" aria-hidden="true" />

          <div className="page-hero__copy">
            <h1>Services</h1>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default ServiceBanner
